import mapboxgl from "mapbox-gl";

/**
 * Required workaround for the decluttered-marker dot behavior.
 *
 * mapbox-gl's `Marker._evaluateOpacity` runs on every map move / render (and via
 * a self-scheduling fade timer) and rewrites the marker root element's inline
 * style: `opacity` and, crucially, `pointerEvents = opacity > 0 ? 'auto' :
 * 'none'`. That continuously clobbers any `pointer-events` we set on the marker
 * (e.g. to make a decluttered marker's invisible footprint non-clickable).
 *
 * It only exists to fade markers occluded by globe / terrain / fog. We render a
 * flat mercator projection with none of those, so opacity is always 1 and the
 * method does nothing useful — it just fights our `pointer-events`. Neutralising
 * it lets us control the marker root's `pointer-events` normally. Non-draggable
 * markers have no other code path touching `pointerEvents`, so this is safe for
 * our usage.
 */
type MarkerWithOpacity = { _evaluateOpacity?: () => void };

const markerPrototype = (mapboxgl.Marker?.prototype ?? undefined) as
  | MarkerWithOpacity
  | undefined;

if (markerPrototype && typeof markerPrototype._evaluateOpacity === "function") {
  markerPrototype._evaluateOpacity = function () {};
}
